import cognitoAuth from '@/cognito'
import store from '@/store'

export const authHelpers = {
  /**
   * Logout from the current device/browser only
   * Use this for standard user-initiated logout
   */
  logoutAndClearStore () {
    cognitoAuth.logout()
    store.commit('logout')
    store.commit('loading/resetLoading')
  },

  /**
   * Logout from ALL devices and invalidate ALL tokens
   * Use this for:
   * - "Logout everywhere" feature
   * - Security-sensitive operations (password change, etc.)
   * - Suspected account compromise
   */
  async globalLogoutAndClearStore () {
    try {
      await cognitoAuth.globalSignOut()
    } catch (err) {
      console.error('Global sign out failed:', err)
      // Fallback to local logout if globalSignOut fails
      cognitoAuth.logout()
    }
    store.commit('logout')
  }
}

export const hexToUtf8 = (hex) => {
  return decodeURIComponent(hex.replace(/(..)/g, '%$1'))
}

export const parseAuthCustomState = (encodedState) => {
  if (!encodedState) {
    return null
  }

  try {
    // Extract the JSON-like hex part
    const hexMatch = encodedState.match(/([0-9a-fA-F]{20,})$/)

    if (!hexMatch) {
      return null
    }

    const hexString = hexMatch[1]

    // Convert from hex to readable JSON
    const jsonString = hexToUtf8(hexString)
    return JSON.parse(jsonString)
  } catch (error) {
    console.error('Failed to parse state:', error)
  }
}
